module.exports = __webpack_public_path__ + "media/src/images/web/sujet-smart-87870154269e12a365df5400e6e13a1e.svg";